// 폼 내 모든 입력값이 비어 있으면 submit 버튼을 비활성화하는 Stimulus 컨트롤러
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "watched"]
  static values = { ignoreNames: { type: Array, default: [] } }

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = this.allEmpty()
  }

  // watched target 이 하나라도 지정된 경우: 해당 element 만 검사.
  //   - checkbox / radio: checked 여부
  //   - 그 외 (text / select / textarea): value 가 빈 문자열인지
  // watched target 이 없는 경우: form.elements 를 순회.
  //   - disabled / 이름없음 / Rails 자동 필드 / ignoreNames 에 명시된 필드 제외
  //   - hidden 은 일괄 제외하지 않음 — select 컴포넌트가 hidden 으로 값을
  //     전송하므로. 의미적 metadata (modal 의 from 등) 는 ignoreNames 로 지정.
  //   - checkbox/radio 는 checked 여부로 판정
  allEmpty() {
    if (this.hasWatchedTarget) {
      return this.watchedTargets.every((el) => this.isElementEmpty(el))
    }

    for (const el of this.element.elements) {
      if (!el.name) continue
      if (el.disabled) continue
      if (el.name === "authenticity_token" || el.name === "_method") continue
      if (this.ignoreNamesValue.includes(el.name)) continue
      if (!this.isElementEmpty(el)) return false
    }
    return true
  }

  isElementEmpty(el) {
    if (el.type === "checkbox" || el.type === "radio") return !el.checked
    return el.value == null || el.value === ""
  }
}
